// extracted by mini-css-extract-plugin
export var container = "container-module--container--2_81v";